const nextIntlConfig = {
  locales: ["en", "es"],
  defaultLocale: "en",
  timeZone: "UTC",
}

export default nextIntlConfig
